// extracted by mini-css-extract-plugin
export default {"antLayout":"CleanPageLayout_antLayout__n6JYj","antContent":"CleanPageLayout_antContent__dWz2T"};